<template>
  <!-- z-20 and no overflow clipping on the section: the search suggestions
       must open over the sections below, not be cut off by this one. -->
  <section class="relative z-20 pt-32 pb-20 lg:pt-44 lg:pb-28 px-6">
    <div class="absolute inset-0 overflow-hidden pointer-events-none" aria-hidden="true">
      <div class="absolute top-20 left-1/2 -translate-x-1/2 w-[800px] h-[600px] bg-deen-gold/20 blur-[120px] rounded-full" />
    </div>

    <div class="relative max-w-7xl mx-auto grid grid-cols-1 lg:grid-cols-12 gap-12 items-center">
      <div v-reveal class="lg:col-span-7 flex flex-col items-start">
        <UiBadge tone="ink" class="mb-6">
          <span class="w-2 h-2 rounded-full bg-deen-gold animate-pulse" aria-hidden="true" />
          {{ t('quran.landing.badge') }}
        </UiBadge>

        <h1 class="text-5xl lg:text-6xl font-display text-deen-ink font-semibold leading-[1.22] tracking-tight mb-6">
          {{ t('quran.landing.titleLine1') }}
          <br />
          <span class="text-gradient">{{ t('quran.landing.titleGradient') }}</span>
        </h1>
        <p class="text-lg text-deen-ink/60 font-medium max-w-xl mb-10 leading-relaxed">
          {{ t('quran.landing.subtitle') }}
        </p>

        <QuranSearchBox size="xl" tone="elevated" class="max-w-2xl" />
        <QuickLinks class="mt-5 max-w-2xl" />

        <div class="mt-10 flex flex-wrap items-center gap-4">
          <AppStoreButton campaign="home-hero" />
          <p class="text-sm text-deen-ink/50 font-medium max-w-[16rem]">{{ t('quran.landing.appNote') }}</p>
        </div>
      </div>

      <div v-reveal="{ delayMs: 200 }" class="lg:col-span-5 flex flex-col items-center lg:items-end gap-5">
        <AyahOfTheDay />
        <NextPrayerCard />
      </div>
    </div>
  </section>
</template>

<script setup>
import { useI18n } from 'vue-i18n';
import NextPrayerCard from '@/components/home/NextPrayerCard.vue';
import AyahOfTheDay from '@/components/quran/AyahOfTheDay.vue';
import QuickLinks from '@/components/quran/QuickLinks.vue';
import QuranSearchBox from '@/components/quran/QuranSearchBox.vue';
import AppStoreButton from '@/components/ui/AppStoreButton.vue';
import UiBadge from '@/components/ui/UiBadge.vue';

const { t } = useI18n();
</script>
